import { ProductError, ProductErrorType } from '../../models';
import { LearnizMedia } from '../media';

export class DocumentViewerData {
  static validate(data: DocumentViewerData, medias: LearnizMedia<any>[], payloadData: any): ProductError[] {
    if (!medias || !medias.length) {
      return [{ type: ProductErrorType.MISSING, property: 'medias', payload: { ...payloadData } }];
    } else if (medias.length > 1) {
      return [{ type: ProductErrorType.TOO_MUCH_VALUES, property: 'medias', payload: { ...payloadData } }];
    }
    return LearnizMedia.validate(medias[0], payloadData);
  }
}

export class DocumentViewerMediaParams {
  showBtnRead: boolean;
  initiallyOpen?: boolean;

  // Was not working the 08/02/2021 if it was useful to someone he would have already complain
  // timer?: number;

  constructor(mediaParams?: DocumentViewerMediaParams) {
    this.showBtnRead = mediaParams ? mediaParams.showBtnRead : true;
    this.initiallyOpen = mediaParams?.initiallyOpen || false;
  }
}
